import { EModalUploadProgress } from "@enums/modalUploadProgress";

export interface IModalUpload {
  id: number;
  status: EModalUploadProgress;
  title: any;
  text: any;
}

export const getModalUpload = (status: EModalUploadProgress) => {
  const modalUpload: IModalUpload[] = [
    {
      id: 0,
      status: EModalUploadProgress.UploadInProgress,
      title: "Your files are being uploaded!",
      text: "Depending on the size of your files, this might take a while.",
    },
    {
      id: 1,
      status: EModalUploadProgress.UploadComplete,
      title: "Your upload is complete",
      text: "All your files have been uploaded successfully.",
    },
  ];

  const modal = modalUpload.find((modal) => modal.status === status)!;

  return {
    title: modal.title,
    text: modal.text,
  };
};
